// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2770R","footer":"ChangeClinic_footer__3lxxM"};